import { graphClient } from '../graph-client'
import {
  GET_LEVELS_HOST,
  GET_LEVELS_SPECTATORS,
  GET_USER_LEVEL_FIRST,
  GET_USER_LEVEL_ONE_BY_USER_ID,
} from './gql'
import type {
  GetLevelsHost,
  GetLevelsSpectator,
  GetUserLevel,
  GetUserLevelStatus,
} from './types'

class LevelService {
  async getSpectator({ take = 20, skip }: GetLevelsSpectator.Input) {
    const request = await graphClient.request<GetLevelsSpectator.Output>(
      GET_LEVELS_SPECTATORS,
      {
        take,
        skip: take * skip,
      },
    )

    return request?.getLevelsSpectators
  }

  async getHost({ take = 20, skip }: GetLevelsHost.Input) {
    const request = await graphClient.request<GetLevelsHost.Output>(
      GET_LEVELS_HOST,
      {
        take,
        skip: take * skip,
      },
    )

    return request?.getLevelsHosts
  }

  async getUserLevel({ userId }: GetUserLevel.Input) {
    const request = await graphClient.request<GetUserLevel.Output>(
      GET_USER_LEVEL_FIRST,
      {
        userId: Number(userId),
      },
    )

    return request?.getUserLevelFirst
  }

  async getUserLevelStatus({ userId }: GetUserLevelStatus.Input) {
    const request = await graphClient.request<GetUserLevelStatus.Output>(
      GET_USER_LEVEL_ONE_BY_USER_ID,
      {
        userId: Number(userId),
      },
    )

    return request?.getUserLevelOneByUserId
  }
}

export const levelService = new LevelService()
